/* eslint-disable */
import { Theme, createStyles, makeStyles } from "@material-ui/core";


export const styles = (theme: Theme) =>
  createStyles({
    root: {
      marginTop: theme.spacing(1.5) + 'px !important',
      boxSizing: 'content-box',
    },
    group: {
      background: 'none !important',
      marginLeft: '20px !important',
      boxSizing: 'content-box',
    },
    content: {
      background: 'none !important',
      '&:hover': {
        background: 'none !important',
      },
      boxSizing: 'content-box',
    },
    label: {
      background: 'none !important',
      display: 'flex',
      alignItems: 'center'
    },
    title: {
      background: 'none !important',
      userSelect: 'none',
      fontSize: '14px',
      color: 'rgba(43, 57, 64, 0.5)',
      lineHeight: '20px'
    },
    icon: {
      width: '8px',
      height: '5px',
      marginRight: theme.spacing(1.5),
      transform: 'rotate(-90deg)',
      '&.rotate': {
        transform: 'rotate(0deg)',
      },
      '& path': {
        'fill': 'rgba(43, 57, 64, 0.5)',

      }
    },
    body: {

    }
  });

export const useStyles = makeStyles(styles);
